import React, { useState, useEffect } from "react";
import { Navigate, useParams, useNavigate } from "react-router-dom";
import { db } from "../../config/firebaseConfig"; // Firebase設定
import { doc, getDoc, query, setDoc, where, updateDoc, collection, getDocs, orderBy, limit, addDoc, serverTimestamp } from "firebase/firestore";
import Modal from "../../components/MasterForm/modal/modal";
import "./MasterForm.css"
import {TreeViewProvider} from "../../context/treeViewContext";
import { nodeName } from "jquery";

const MasterForm = ({ onEditingChange }) => {
    const [data, setData] = useState([]); // Firestore データを保存する状態
    const [loading, setLoading] = useState(true); // ローディング状態
    const [documentID, setDocumentID] = useState(null);
    const { masterID } = useParams(); // URLのパラメータを取得 (id)
    const [isEditing, setIsEditing] = useState(!masterID);
    const [initialFormData, setInitialFormData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // console.log('isEditing', isEditing)
    //初期状態(新規作成時は空っぽ)
    const currentProjectID = localStorage.getItem("currentProjectID");
    const [formData, setFormData] = useState({
        masterID: "",
        name: "",
        Abbreviation_name: "",
        maker: "",
        user: "",
        isCategory: "false",
        location_id: "",
        remark1: "",
        remark2: "",
        parentID: "",
        categoryName: "",
        ModifiedDate: "",
        UpdatedBy: "",
        deleted: "",
        projectID: currentProjectID,
    });
    const navigate=useNavigate();

    const isHidden = useState(Boolean(masterID)); //masterIDがあれば編集モード
    

    //masterIDからfirestoreからデータ取得
    const fetchDataByMasterID= async()=>{
        // 編集モードならFirestoreからデータ取得
            try {
                // masterID を使ってドキュメントを参照
                const q = query(collection(db, "00_DeviceMasterTable"),
                where("masterID", "==", masterID),
                where("projectID", "==", currentProjectID)
            );
                const querySnapshot = await getDocs(q);

                // データが見つかった場合
                if (!querySnapshot.empty) {
                    querySnapshot.forEach((doc) => {
                        // console.log(doc.id, " => ", doc.data());
                        setFormData(doc.data()); // Firestore のデータをセット
                        setDocumentID(doc.id);
                    });

                } else {
                    // console.log("❌ masterIDに一致するデータがありません");
                }
                } catch (error) {
                    // console.error("❌ データ取得エラー:", error);
                }
            };
    // `masterID` の最大値を取得する関数
    const fetchMaxMasterID = async () => {
        const q = query(
            collection(db, "00_DeviceMasterTable"),
            where("projectID", "==", currentProjectID),
            orderBy("masterID", "desc"),
            limit(1)
        );
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
            const maxID = querySnapshot.docs[0].data().masterID; // 最大値取得
            const nextID = generateNextMasterID(maxID); // `maxID + 1` の新しいIDを作成
            setFormData(prev => ({ ...prev, masterID: nextID })); // 更新
        } else {
            setFormData(prev => ({ ...prev, masterID: "001" })); // データがない場合は "001" にする
        }
    };

    // `masterID` のフォーマット (`001, 002, 003` のような形式) を維持する関数
    const generateNextMasterID = (currentMaxID) => {
        // ① 英字 + 数字 を分離する (例: "C007" → prefix="C", numericPart="007")
        const match = currentMaxID.match(/^([A-Za-z]*)(\d+)$/);
    
        if (!match) return "001"; // マッチしなかった場合のデフォルト値

        const prefix = match[1];  // 英字部分 (例: "C")
        const numericPart = match[2]; // 数字部分 (例: "007")

        // ② 数字部分を数値に変換し、+1 する
        const nextNumericID = String(parseInt(numericPart, 10) + 1).padStart(numericPart.length, "0");

        // ③ 英字部分 + 数字部分 を結合して次の `masterID` を作成
        return prefix + nextNumericID;  // 例: "C007" → "C008"
    };
    
    // 親IDの選択時の処理
    const handleParentSelect = (selectedID, nodeName) => {
        setFormData((prev) => ({
            ...prev,
            parentID: selectedID.split('_')[1], // 選択したノードのIDを格納。splitで"master_"を削除
            categoryName: nodeName??null,
        }));
        setIsModalOpen(false); // モーダルを閉じる
    };

    const handleEditClick = () => {
        setInitialFormData(formData); // 編集開始前のデータを保存
        setIsEditing(true);
    };

    const handleCancelClick = () => {
        const confirmCancel = window.confirm("変更内容が登録されません。編集作業を中止しますか？");
        if (confirmCancel) {
            if(masterID){
                //編集画面の場合
                setFormData(initialFormData); // 編集前の状態に戻す
                setIsEditing(false); // 編集モードを解除
            }else{
                //新規登録画面の場合
                navigate("/gantt");
            }
        }
        // 「いいえ」の場合は何もせず、編集を継続
    };
    
     // 状態が変わったときに親コンポーネントの状態を更新
    useEffect(() => {
        if (onEditingChange) {
        onEditingChange(isEditing);  // 親コンポーネントに状態を伝える
        }
    }, [isEditing, onEditingChange]);
    


    

    // ノード削除関数
    const handleLogicallyDelete = async (collectionName, id) => {
        const docRef = doc(db, collectionName, id);
        try {
          await updateDoc(docRef, {
            deleted: true,
            updatedAt: serverTimestamp(), // 任意：更新日時の記録
          });
          console.log("削除が完了しました");
          navigate("/gantt");
        } catch (error) {
          console.error("削除に失敗しました:", error);
        }
      };
    
    // 画面を開いたときに実行。
    useEffect(()=>{
        if(masterID){
            fetchDataByMasterID();
            setFormData(prev => ({ ...prev, masterID })); // 既存の masterID をセット
        }else{
            fetchMaxMasterID();
        }
    }, [masterID]);

    // 保存処理
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (masterID) {
                //　編集モード
                // 🔹 Firestore から masterID に一致するデータを検索
                const q = query(
                    collection(db, "00_DeviceMasterTable"),
                    where("masterID", "==", masterID), // masterID フィールドが一致するデータを検索
                    where("projectID", "==", currentProjectID)
                );
                const querySnapshot = await getDocs(q);
    
                if (!querySnapshot.empty) {
                    // 🔹 最初の一致するドキュメントを取得
                    const docRef = querySnapshot.docs[0].ref;
                    const existingData = querySnapshot.docs[0].data();
    
                    // 🔹 既存データを formData にマージ
                    const updatedFormData = { ...existingData, ...formData };
    
                    // 🔹 Firestore を更新
                    await updateDoc(docRef, updatedFormData);
                    alert('更新が完了しました')
                    setIsEditing(false)
                    // navigate("/gantt");
                } else {
                    console.error("エラー: 該当のドキュメントが存在しません");
                }
            } else {
                // 新規作成モード (追加)
                const newRef = await addDoc(collection(db, "00_DeviceMasterTable"), formData);
                console.log("✅ 新規ドキュメント作成:", newRef.id);
                navigate("/gantt")
            }
        } catch (error) {
            console.error("エラー:", error);
        }
    };

    return (
        <TreeViewProvider>
        <div className="tab-container">
            <h2>{masterID ? "" : "新規作成画面"}</h2>
            <>
            <form onSubmit={handleSubmit} className="form-container">
                <div className="header">
                        {isEditing ? (
                            <>
                            <div className="button-group">
                                <button type="submit" className="MasterFormSubmit">{masterID ? "更新" : "新規登録"}</button>
                                <button type='button' onClick={handleCancelClick} className='MasterFormCancel'>
                                キャンセル
                                </button>
                                <button
                                    type="button"
                                    className="MasterFormDelete"
                                    style={{ display: masterID ? "inline-block" : "none" }}//hidden={true}で非表示にならなかったため、この記述とした。
                                    // hidden={!isHidden}
                                    onClick={() => {
                                        const confirmDelete = window.confirm("本当に削除しますか？\n削除すると該当の子データも非表示になります。");
                                        if (confirmDelete && documentID) {
                                          handleLogicallyDelete("00_DeviceMasterTable", documentID);
                                        }
                                      }}
                                >
                                    削除
                                </button>

                            </div>
                            </>
                                ) : (
                            <button type='button' onClick={handleEditClick} className='edit-button'>
                                編集
                            </button>                 
                        )}
                    
                </div>
                <body>
            {/* <!-- left--> */}    
                <div className="left-container column">
                {/* left */}
                    {/* <!-- 種別 --> */}
                    <div className="form-element">
                        <div className="title">種別</div>
                        <label className="radio-element">
                            <input type="radio" name="type" value="device" checked disabled={isEditing}/>装置
                            {/* <input type="radio" name="type" disabled={isEditing}/>部屋 */}
                        </label>
                    </div>
                    {/* <!-- マスターID --> */}
                    <div className="form-element">
                        <div className="title">マスターID★</div>
                        <input 
                            id='masterID' 
                            name="masterID" 
                            className="InputBox SelectBox always-disabled" 
                            disabled
                            value={formData.masterID ||""} // Firestore の値 or 空

                        />
                    </div>
                    {/* 名称 */}
                    <div className="form-element">
                        <div className="title">名称★</div>
                        <input 
                            name="name" 
                            id="name" 
                            className="InputBox TextBox buttonclassName" 
                            type="text" 
                            disabled={!isEditing} 
                            required
                            value={formData.name || ""} // Firestore の値 or 空
                            onChange={(e)=> setFormData({...formData, name: e.target.value})}
                        />
                        </div>
                    {/* <!-- 装置略称 --> */}
                    <div className="form-element">
                        <div className="title">装置略称</div>
                        <input 
                            name="AbbreviationName" 
                            id="AbbreviationName" 
                            className="InputBox TextBox" 
                            type="text" 
                            disabled={!isEditing}
                            value={formData.AbbreviationName||""} // Firestore の値 or 空
                            onChange={(e)=> setFormData({...formData, AbbreviationName: e.target.value})}
                        />
                        </div>
                    {/* <!-- メーカ --> */}
                    <div className="form-element">
                        <div className="title">メーカ名</div>
                        <input 
                            name="maker" 
                            id="maker" 
                            className="InputBox TextBox" 
                            type="text" 
                            disabled={!isEditing}
                            value={formData.maker || ""} // Firestore の値 or 空
                            onChange={(e)=> setFormData({...formData, maker: e.target.value})}
                        />
                    </div>
                    {/* <!-- 担当者 --> */}
                    <div className="form-element">
                        <div className="title">担当者</div>
                        <input 
                            name="user" 
                            id="user" 
                            className="InputBox TextBox" 
                            type="text" 
                            disabled={!isEditing}
                            value={formData.user || ""} // Firestore の値 or 空
                            onChange={(e)=> setFormData({...formData, user: e.target.value})}
                        />
                    </div>
                    {/* <!-- isCategory --> */}
                    <div className="form-element hidden">
                        <div className="title">isCategory</div>
                        <textarea 
                            name="isCategory" 
                            id="isCategory" 
                            className="textarea InputBox" 
                            rows="10" 
                            cols="40" 
                            disabled={!isEditing} 
                            value={formData.isCategory || ""}
                            onChange={(e)=> setFormData({...formData, isCategory: e.target.value})}
                        />
                    </div>
                    {/* <!-- location_id --> */}
                    <div className="form-element hidden">
                        <div className="title">location_id</div>
                        <input name="location_id" id="location_id" className= "InputBox TextBox" type="text" disabled={isEditing}></input>
                    </div>
                    {/* <!-- remark1 --> */}
                    <div className="form-element">
                        <div className="title">備考1</div>
                        <textarea
                            name="remark1"
                            id='remark1'
                            className="textarea InputBox"
                            rows="10"
                            cols="40"
                            placeholder="備考1" 
                            disabled={!isEditing}
                            value={formData.remark1 || ""}
                            onChange={(e)=> setFormData({...formData, remark1: e.target.value})}
                        />
                    </div>
                    {/* <!-- memo2 --> */}
                    <div className="form-element hidden">
                        <div className="title" >備考2</div>
                        <textarea name="remark2" id='remark2' className="textarea InputBox"
                        rows="10"
                        cols="40"
                        placeholder="備考2" 
                        disabled={!isEditing}
                        value={formData.remark2 || ""}>
                        onChange={(e)=> setFormData({...formData, remark2: e.target.value})}
                        </textarea>
                    </div>
                </div>

            {/* <!-- right--> */}
                <div className="right-container column">
                    <div className="message">マスターの配置先を選択してください。</div>
                    <button 
                    type="button" 
                    id="modalOpenbutton" 
                    className="button-modalOpen" 
                    disabled={!isEditing}
                    onClick={()=> setIsModalOpen(true)}>
                        配置先選択
                    </button>

                {/* modal画面呼び出し */}
                <Modal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                onSelect={handleParentSelect} 
                masterID={masterID}
                />

                {/* <!-- カテゴリーID --> */}
                    <div className="form-element">
                        <div className="title">親ID★</div> {/*親ID★(カテゴリID) */}
                        <input 
                            name="parentID" 
                            id="parentID" 
                            className="InputBox TextBox always-disabled" 
                            type="text" 
                            disabled
                            required
                            value={formData.parentID || ""} // Firestore の値 or 空
                        />
                    </div>
                    {/* <!-- カテゴリー名 --> */}
                    <div className="form-element">
                        <div className="title">親名★</div>{/*親名★(カテゴリ名) */}
                        <input name="categoryName" id="categoryName" className= "InputBox TextBox always-disabled" type="text"
                        disabled
                        required
                        value={formData.categoryName || ""}></input>
                    </div>
                    {/* <!-- 更新日 --> */}
                    <div className="inputContainer hidden">
                        <label for="ModifiedDate">最終更新日</label>
                        <input
                            id="ModifiedDate"
                            type="date"
                            name="ModifiedDate"
                            className="inputbox date"
                            disabled={!isEditing}>
                        </input>
                    </div>
                    {/* <!-- 更新者 --> */}
                    <div className="inputContainer hidden">
                        <label for="UpdatedBy">最終更新者</label>
                        <input
                            id="UpdatedBy"
                            name="UpdatedBy"
                            disabled={!isEditing}
                            className="inputbox">
                        </input>
                    </div>
                    {/* <!-- deleted --> */}
                    <div className="inputContainer hidden">
                        <label for="deleted">deleted</label>
                        <input
                            name="deleted"
                            disabled={!isEditing}
                            className="inputbox">
                        </input>
                    </div>    
                </div>
                </body>
                
            </form>
            </>
        </div>
        </TreeViewProvider>
    );
};

export default MasterForm;
